import { $api } from "../generated/client";

/**
 * Fetch global config flags (collection `config`, doc `production`).
 * Super admins only (SuperAdminGuard): disable it for anyone else.
 */
export function useSuperAdminConfig(isEnabled = true) {
  return $api.useQuery(
    "get",
    "/super-admin/config",
    {},
    { enabled: isEnabled },
  );
}

/** Update global config flags. */
export function useUpdateSuperAdminConfig() {
  return $api.useMutation("patch", "/super-admin/config");
}
